<template>

  <main class="main activity max-width amateur">
    <article v-if="user && user.id">   
      <div class="welcome">
        <div class="title-medium"><span class="light">Bentornato</span> {{user.name}}!</div>

        <div class="edit-data">
          <router-link to="report" class="button button-regular button-azure button-anim">programmazione SIAE</router-link>
          <router-link to="edit-profile" class="button button-regular button-aqua button-anim">modifica i tuoi dati</router-link>
          <a class="button button-regular button-yellow button-anim" href="#0" @click.prevent="logout">logout</a>
        </div>

      </div>

      <div v-if="activities.length">
        <h1 class="title-medium">Riepilogo delle ultime attività:</h1>
        <div class="activity-block">
          <div class="downloads row-2">

            <div class="download" v-for="activity in activities">
              <img class="download-cover" v-if="activity.song.album.cover.path" :src="activity.song.album.cover.path" />
              <img class="download-cover" v-else src="/themes/caramba/assets/images/album.jpg" />
              <div class="download-info">
                <div class="download-info-inner">
                  <h2 class="download-artist">{{activity.song.album.artist.name}}</h2>
                  <p class="download-song">{{activity.song.title}}</p>
                  <p class="download-repertorio">{{activity.song.album.category && activity.song.album.category.name}}</p>
                  <p class="download-repertorio">Scaricato in data {{activity.downloadDate}}</p>
                </div>
              </div>
              <div class="download-icon">
                <span>
                  <img :src="activity.iconUrl">
                  <span class="small arial download-label">{{activity.typeName}}</span>
                </span>
              </div>
            </div>
          
          </div>
        </div>
      </div>

      <h1 v-else class="title-medium">Nessuna attività recente</h1>
    </article>
    
    <article v-else>
      <h1 class="title-medium">Prima effetua il login!</h1>
      <p>Per accedere alla tua area utente, prima devi <router-link to="login" class="green-link">effettuare il login qui</router-link>.</p>
    </article>

    <DownloadModalAlert />

  </main>
</template>

<script>
  import * as Cookies from 'js-cookie';
  import axios from 'axios/dist/axios';
  import DownloadModalAlert from './DownloadModalAlert';

  export default {
    props: ['user', 'isCheckingLogin'],

    components: {

        DownloadModalAlert

    },

    data() {
      return {
        activities: []
      }
    },
    
    created() {
      if(this.$props.isCheckingLogin) {
        this.$eventBus.$on('login:complete', () => this.setup());
      } else {
        this.setup();
      }
    },

    mounted() {
      document.title = 'Caramba - Area Utente';
    },
    
    methods: {
      setup: function() {
        let token = Cookies.get('caramba-token');
        const headers = { 'Authorization': 'Bearer ' + token };
        const getDownloadListInstance = axios.create({headers});

        getDownloadListInstance.post('/api/v1/download/list')
          .then(resp => {
            this.activities = resp.data.data.map(activity => {
              activity.typeName = this.getDownloadType(activity.type);
              activity.iconUrl = this.getIconUrl(activity);
              activity.downloadPath = this.getDownloadPath(activity);
              activity.downloadDate = this.getDownloadDate(activity.created_at);
              return activity;
            });
          })
          .catch(err => {

          });
      },

      logout: function() {
        this.$eventBus.$emit('user:logout', {goToLogin: true});
      },

      getDownloadDate: function(date) {
        return date.split(' ')[0].split('-').reverse().join('/');
      },

      getDownloadPath: function(activity) {
        return '/api/v1/download/song/' + activity.user_id + '/' + activity.song_id + '/' + activity.type;
      },

      getDownloadType: function(type) {
        switch(type) {
          case 'mp3':
            return 'Mp3';
          break;
          case 'mp3_base':
            return 'Base mp3';
          break;
          case 'mid':
            return 'Base midi';
          break;
          case 'sheet':
            return 'Spartito';
          break;
          case 'lyrics':
            return 'Testo';
          break;
        }
      },

      getIconUrl: function(activity) {
        let filename = '';
        switch(activity.type) {
          case 'mp3':
            filename = 'mp3_on';
          break;
          case 'mp3_base':
            filename = 'mp3_backing_on';
          break;
          case 'mid':
            filename = 'midi_backing_on';
          break;
          case 'sheet':
            filename = 'score_on';
          break;
          case 'lyrics':
            filename = 'lyrics_on';
          break;
        }
        return 'themes/caramba/assets/images/' + filename + '.svg';
      },

      showDownloadAlert() {

          setTimeout(() => {

              this.$eventBus.$emit('download:show_alert', {msg: "File scaricato correttamente"});

          },500)


      }

    }
  };
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/vue/components/User.vue